// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';

// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { FormSubmitButtonProps } from './types';

export const FormSubmitButton: React.FC<
  React.PropsWithChildren<FormSubmitButtonProps>
> = ({ className, ...rest }) => (
  <div className={className}>
    <PrimaryButton
      {...rest}
      type="submit"
      className="sm:hidden"
      size="s"
      full
    />
    <PrimaryButton
      {...rest}
      type="submit"
      className="hidden sm:inline-flex"
      size="l"
      full
    />
  </div>
);

export default FormSubmitButton;
